import React, { useState } from 'react';
import './imageGallery.css';

const ImageGallery = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const openLightbox = (image) => {
    setSelectedImage(image);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  return (
    <section className="image-gallery-section">
      <div className="image-gallery-container">
        {images.map((image, index) => (
          <div
            key={index}
            className="gallery-item"
            onClick={() => openLightbox(image)}
            style={image.rowSpan ? { gridRow: `span ${image.rowSpan}` } : {}}
          >
            <img src={image.src} alt={image.alt} className="gallery-image" />
            <div className="gallery-overlay">
              <p className="gallery-title">{image.title}</p>
            </div>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close-btn" onClick={closeLightbox}>×</button>
            <img src={selectedImage.src} alt={selectedImage.alt} className="lightbox-image" />
            {selectedImage.description && <p className="lightbox-description">{selectedImage.description}</p>}
          </div>
        </div>
      )}
    </section>
  );
};

export default ImageGallery; 